<template>
  <div>
    <LoadingContainer v-if="loading"/>

    <div v-else>
      <FormPanel
          headline="Create Content Block"
          :initial="{block_driver_parameters: {}}"
          :errors="errors"
          :block-drivers="blockDrivers.filter(blockDriver => blockDriver.attributes.layout_categories.includes('content-pages'))"
          :content-row="contentRow"
          :portal="portal"
          @submit="submit"
      />
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import FormPanel from "../../../../../../../../components/Administration/ContentBlocks/Panels/Form";
import LoadingContainer from '../../../../../../../../components/Layout/LoadingContainer'

export default {
  components: {FormPanel, LoadingContainer},

  props: {
    portal: {
      required: true
    },

    blockDrivers: {
      required: true
    },

    layoutCategories: {
      required: true
    }
  },

  data() {
    return {
      contentRow: null,

      loading: true,

      errors: {}
    }
  },

  mounted() {
    this.load()
  },

  methods: {
    load() {
      http.get('/api/v2/content-pages/' + this.$route.params.contentPageId + '/content-rows/' + this.$route.params.contentRowId)
          .then(response => {
            this.contentRow = response.data.data

            this.loading = false
          })
    },

    submit(data) {
      http.post('/api/v2/content-blocks', {...data, content_row_id: this.contentRow.id})
          .then(() => {
            notify.success('The content block was saved')

            this.$router.push('../../../edit')
          })
          .catch(error => {
            if (error.response.status === 422) {
              this.errors = error.response.data.errors
            }

            throw error
          })
    },
  }
}
</script>
